// JsFromRoutes CacheKey 4102d003e3b9732fbd665ef37b178cba
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  destroy: /* #__PURE__ */ definePathHelper('delete', '/consumer/gift_bookmarked_places'),
  create: /* #__PURE__ */ definePathHelper('post', '/consumer/gift_bookmarked_places'),
}
